import { SpaceAirInfo } from "../services/iotServices";

export const getAirLevelAverage = (space?: SpaceAirInfo) => {
  const defaultLevelAverage = 50;

  if (space === undefined) {
    return defaultLevelAverage;
  }

  const levelList = space.tag
    ?.filter((tag) => tag.level)
    .map((tag) => Number(tag.level.replace("level0", "")));
  const levelAverage =
    100 -
    (levelList?.reduce((acc, cur) => acc + cur, 0) / levelList?.length - 1) *
      20;

  return levelAverage;
};
